if (!customElements.get('product')) {
  customElements.define(
    'product-details',
    class NimbiAccordion extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
      }

      connectedCallback() {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.submitHandler.bind(this));

        this.variantContainer = this.querySelector('.variant-container');
        this.variants = this.variantContainer.querySelectorAll('.variant-container input[data-variant]');

        this.variantContainer.addEventListener('change', this.onVariantChange.bind(this));
      }

      async submitHandler(event) {
        event.preventDefault();
        const buttonText = this.button.textContent;
        this.button.textContent = 'Adding...';

        const config = (type = 'javascript') => ({
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: `application/${type}`,
          },
          // We get the data from the product form it self
          body: new FormData(this.form),
        });

        try {
          // Add main product to cart
          await fetch(`${window.routes.cart_add_url}`, config());
          
          // Add free gifts to cart if available
          if (window.availableFreeGifts && window.availableFreeGifts.length > 0) {
            const freeGiftPromises = window.availableFreeGifts.map(giftId => {
              const formData = new FormData();
              formData.append('id', giftId);
              formData.append('quantity', 1);
              formData.append('properties[_Free gift]', 'true');
              
              return fetch(`${window.routes.cart_add_url}`, {
                method: 'POST',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  Accept: 'application/javascript',
                },
                body: formData
              });
            });
            
            await Promise.all(freeGiftPromises);
            
            // Apply discount code after adding free gifts
            if(window.freeGiftDiscountCode){
              await this.applyDiscountCode(window.freeGiftDiscountCode);
            }
          }

          window.updateCartCount();
          this.button.disabled = false;
          this.button.textContent = 'Added!';

          setTimeout(() => {
            this.button.textContent = buttonText;
          }, 2000);
        } catch (error) {
          console.error(error);
        }
      }

      async applyDiscountCode(discountCode) {
        console.log('Applying discount code:', discountCode);
        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              discount: discountCode
            })
          });
          if (!response.ok) {
            console.warn(`Failed to apply discount code: ${discountCode}`);
          }
        } catch (error) {
          console.error('Error applying discount code:', error);
        }
      }

      onVariantChange(event) {
        const variant = event.target.value;
        const mediaPosition = event.target.getAttribute('data-media-position');

        if (variant) {
          this.getPageData(variant).then(() => {
            window.history.replaceState({}, '', `${location.href.replace(location.search, '')}?variant=${variant}`);

            gallerySlider.go(mediaPosition - 1);
          });
        }
      }

      async getPageData(variantId) {
        this.setAttribute('data-loading', 'true');

        this.querySelectorAll('input, button').forEach((input) => {
          input.disabled = true;
        });

        return fetch(location.pathname + '?variant=' + variantId)
          .then((r) => r.text())
          .then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            const productEl = doc.querySelector('product-details');

            this.replaceWith(productEl);
          });
      }
    }
  );
}
